import { TaxesContext } from "../providers/TaxesProvider";
import { useContext } from "react";

export default function useTaxesContext() {
  return useContext(TaxesContext);
}
